import React, { createContext, useEffect, useState } from "react";
import axios from "axios";

export const PackagesContext = createContext();

export const PackagesProvider = ({ children }) => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get("https://apiv2.iklimdigitals.com/api/packages/")
      .then((res) => {
        setPackages(res.data.packages); // store all packages
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching packages:", err);
        setError("Failed to load packages.");
        setLoading(false);
      });
  }, []);

  return (
    <PackagesContext.Provider value={{ packages, loading, error }}>
      {children}
    </PackagesContext.Provider>
  );
};
